import { render } from "./ClientesList.vue?vue&type=template&id=69206abd&scoped=true"
import script from "./ClientesList.vue?vue&type=script&lang=js"
export * from "./ClientesList.vue?vue&type=script&lang=js"

import "./ClientesList.vue?vue&type=style&index=0&id=69206abd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69206abd"]])

export default __exports__